import { _ } from '../../../lib';
const DEFAULT_VISIBILITY_TEXT = {
    composeVisibleToTarget: 'Visible to participant',
    composeHiddenFromTarget: 'Internal only',
    badgeVisibleToTarget: 'Visible to participant',
    badgeHiddenFromTarget: 'Internal only',
    createThreadFieldLabel: 'Visible to participant',
};
export const getContextID = (props) => props.contextID;
export const getContextScopeKey = (props) => {
    const privilegeScope = props.isPrivilegedView === true ? 'privileged' : 'default';
    if (props.contextScopeKey != null) {
        return `${props.facility}:${props.contextScopeKey}:${privilegeScope}`;
    }
    return `${props.facility}:${getContextID(props)}:${privilegeScope}`;
};
export const getIsPrivilegedView = (props) => props.isPrivilegedView ?? false;
export const getActorContextID = (props) => props.actorContextID ?? null;
export const getTargetContextDisplayName = (props) => props.targetContextDisplayName ?? null;
export const getVisibilityText = (props) => ({
    ...DEFAULT_VISIBILITY_TEXT,
    ...props.visibilityText,
});
export const getCanControlVisibility = (data) => data.canControlVisibility ?? false;
export const getMessageIsPrivileged = (props, message) => {
    if (props.resolveMessageIsPrivileged != null) {
        return props.resolveMessageIsPrivileged(message);
    }
    return message.IsPrivileged;
};
export const getMessageIsVisibleToTarget = (props, message) => {
    if (props.resolveMessageIsVisibleToTarget != null) {
        return props.resolveMessageIsVisibleToTarget(message);
    }
    return getDefaultMessageIsVisibleToTarget(message);
};
export const getDefaultMessageIsVisibleToTarget = (message) => message.VisibleToTarget;
export const getMessageAuthorUserID = (props, message) => {
    if (props.resolveMessageAuthorUserID != null) {
        return props.resolveMessageAuthorUserID(message);
    }
    return message.AuthorUserID;
};
export const getMessageAuthorContextID = (props, message) => {
    if (props.resolveMessageAuthorContextID != null) {
        return props.resolveMessageAuthorContextID(message);
    }
    return message.AuthorContextID;
};
export const getDefaultState = () => ({
    threads: [],
    messages: [],
    canControlVisibility: false,
    selectedThreadID: null,
    sidebarView: {
        searchText: '',
        showInactive: false,
    },
    messageText: '',
    visibleToTarget: true,
    loading: true,
    sending: false,
    error: '',
    copiedMessageID: null,
    composerHeight: 0,
});
const shouldShowThread = (thread, showInactive) => Boolean(showInactive) || thread.ResolvedAt == null;
const getFallbackThreadID = (input) => _.chain(input.threads)
    .filter(thread => shouldShowThread(thread, input.showInactive))
    .map(thread => thread.ID)
    .first()
    .value() ?? null;
export const getSelectedThreadID = (input) => {
    if (input.selectedThreadID == null) {
        return getFallbackThreadID(input);
    }
    const selectedThread = _.find(input.threads, thread => thread.ID === input.selectedThreadID);
    if (selectedThread != null && shouldShowThread(selectedThread, input.showInactive)) {
        return selectedThread.ID;
    }
    return getFallbackThreadID(input);
};
export const clearCopyTickTimer = (rs) => {
    if (rs.refs.copyTickTimer.current != null) {
        window.clearTimeout(rs.refs.copyTickTimer.current);
        rs.refs.copyTickTimer.current = null;
    }
};
export const autoResizeTextarea = (textarea) => {
    if (textarea == null) {
        return;
    }
    textarea.style.height = 'auto';
    const nextHeight = Math.min(Math.max(textarea.scrollHeight, 44), 200);
    textarea.style.height = `${nextHeight}px`;
    textarea.style.overflowY = textarea.scrollHeight > 200 ? 'auto' : 'hidden';
};
export const updateViewportAnchor = (rs) => {
    const viewport = rs.refs.messagesViewport.current;
    if (viewport == null) {
        return;
    }
    const distanceToBottom = viewport.scrollHeight - (viewport.scrollTop + viewport.clientHeight);
    rs.refs.isViewportAnchored.current = distanceToBottom <= 20;
};
export const isIgnoredFocusTarget = (target) => {
    if (!(target instanceof Element)) {
        return true;
    }
    return Boolean(target.closest('button, input, textarea, a, [role="button"], [contenteditable="true"], ' +
        '[data-chat-interactive="true"]'));
};
export const focusTextarea = (rs) => {
    rs.refs.textarea.current?.focus();
};
export const focusTextareaIfAllowed = (rs, target) => {
    if (!isIgnoredFocusTarget(target)) {
        focusTextarea(rs);
    }
};
//# sourceMappingURL=utils.js.map